import { SlashCircle } from '@/assets/icons'
import { Link } from '@/components/link/Link'
import { Modal, ModalContent, ModalFooterWithActions } from '@/components/modal'
import { kPaxtonAppBaseDomain } from '@/constants/constants-links'
import { accountPaths } from '@/routing/paths'

type OcrUploadBlockedModalProps = {
  open: boolean
  onDismiss: () => void
  showUsage?: boolean
}

export function OcrUploadBlockedModal({ open, onDismiss, showUsage = false }: OcrUploadBlockedModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onDismiss()
      }}
    >
      <ModalContent
        title="OCR page limit reached"
        subtitle="Cannot upload files requiring OCR (.pdf) while your quota is full"
        titleIcon={<SlashCircle className="size-6 text-brand-neutral-700" aria-hidden />}
        width="md"
        height="max-full"
        showCloseButton
        footer={<ModalFooterWithActions primaryAction={{ label: 'OK', onClick: onDismiss }} />}
      >
        {showUsage && (
          <Link href={new URL(accountPaths.usage, kPaxtonAppBaseDomain()).toString()} external onClick={onDismiss} aria-label="View Usage (opens in a new tab)">
            View Usage
          </Link>
        )}
      </ModalContent>
    </Modal>
  )
}
